import { useState } from "react";
import { ChevronDown, ClipboardList, Target, BookOpen, PlayCircle, StickyNote } from "lucide-react";
import RichBlock from "@/components/vetting/RichBlock";

const sentence = (s) => (s === s.toUpperCase() ? s.charAt(0) + s.slice(1).toLowerCase() : s)
  .replace(/\b(dtm|mg1|mg2|bp1|bp2|fp1|fp2|ves|pbo|php|abi|90dcr|htp)\b/gi, (m) => m.toUpperCase());

function Blocks({ sec, testid, checklist }) {
  return (
    <div className="space-y-3">
      {sec.blocks.map((b, i) => <RichBlock key={i} runs={b} checklist={checklist} testid={`${testid}-b${i}`} />)}
    </div>
  );
}

function Notes({ sec, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <section className="rounded-2xl border border-slate-200 bg-white" data-testid={testid}>
      <button onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid={`${testid}-toggle`}
              className="w-full flex items-center gap-3 p-4 sm:p-5 text-left">
        <StickyNote className="w-5 h-5 text-[#C9A961]" />
        <span className="font-serif text-lg text-[#0A1F44] flex-1">{sentence(sec.label)}</span>
        <span className="text-xs text-slate-500">{open ? "Hide" : "Show"}</span>
        <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 sm:px-5 pb-5"><Blocks sec={sec} testid={testid} /></div>}
    </section>
  );
}

const ICON = { resources: BookOpen, example: PlayCircle, homework: ClipboardList };

export default function VettingSection({ sec, testid }) {
  if (sec.type === "purpose") {
    return (
      <section className="rounded-2xl border-l-4 border-[#C9A961] bg-[#F7F5EF] p-4 sm:p-5" data-testid={testid}>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.24em] text-[#8A6D1F] font-semibold mb-1.5"><Target className="w-3.5 h-3.5" /> Purpose</div>
        <Blocks sec={sec} testid={testid} />
      </section>
    );
  }
  if (sec.type === "notes") return <Notes sec={sec} testid={testid} />;
  if (!sec.blocks.length) {
    return <div className="text-[10px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold pt-2" data-testid={testid}>{sec.label}</div>;
  }
  const Icon = ICON[sec.type];
  const box = sec.type === "homework" ? "bg-[#FCF6DF] border border-[#C9A961]/60" : "bg-white border border-slate-200";
  return (
    <section className={`rounded-2xl p-4 sm:p-5 ${box}`} data-testid={testid}>
      <h3 className="font-serif text-lg mb-3 flex items-center gap-2 text-[#0A1F44]">
        {Icon && <Icon className="w-5 h-5 text-[#C9A961]" />}{sentence(sec.label)}
      </h3>
      <Blocks sec={sec} testid={testid} checklist={sec.type === "homework"} />
    </section>
  );
}
